module.exports = __webpack_public_path__ + "img/87.5cc87c4d.jpg";